/**
 * @file DeactivationCheckbox
 */
'use strict'

/**
 * @classname DeactivationCheckbox
 * @classdesc DeactivationCheckbox
 */
export default class DeactivationCheckbox {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('DeactivationCheckbox.constructor')
		this._$e = $e
		this._target = $e.attr('data-target')
		this._$target = $e.find('.input-checkbox[value="' + this._target + '"]')
		this._$checkboxs = $e.find('.input-checkbox')

		this._$checkboxs.each((idx, element) => {
			const $element = $(element);
			$element.on('click', () => this.onClick($element))
		});
	}

	/**
	 * クリックのコールバック
	 *
	 * @memberof DeactivationCheckbox
	 * @return {undefined}
	 */
	onClick(e) {
		console.log('DeactivationCheckbox.onClick')
		const _$e = $(e)
		const val = _$e.val()
		const $siblings = _$e.parent('.custom-checkbox').siblings('.custom-checkbox').find('.input-checkbox');

		if (_$e.prop('checked')) {
			// 特になしがチェックされた時、他のチェックボックスを非活性にする
			if(val === this._target) {
				$siblings.prop({
					'disabled': true
				});
			// 特になし以外がチェックされた時、特になしを非活性にする
			}else{
				this._$target.prop({
					'disabled': true
				});
			}
		// チェックが外された時
		} else {
			// 特になしのチェックが外された時、他のチェックボックスを活性にする
			if(val === this._target) {
				$siblings.prop({
					'disabled': false
				});
			// 特になし以外のチェックが外された時、他にチェックされているか調べる
			}else{
				let cnt = 0
				$siblings.each((idx, sibling) => {
					const $sibling = $(sibling);
					if($sibling.prop('checked') && $sibling.val() !== this._target){
						cnt++
					}
				});
				if(cnt === 0) {
					this._$checkboxs.prop({
						'disabled': false
					});
				}
			}
		}
	}
}
